export default __webpack_public_path__ + "static/media/Helm of the Assailant.34460c4a.jpg";